import React, { useState, useRef } from "react";
import { Row, Col, Modal, Form, Button, Container } from "react-bootstrap";
import { Button as AntBtn, Card, Modal as AntModal, Row as AntRow, Spin } from "antd";
import Title from "antd/es/typography/Title";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import { useNavigate, useLocation } from "react-router-dom";
// import { getGroupOrderID } from "../../Helpers/apiCalls/OrderApi";
import toast from "react-hot-toast";
import "./AllTables.css";
import {
  // getRestoLogin,
  getRole,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common";
//images
import CommonPrint from "../../Components/Print/CommonPrintReceipt";
import {
  cancelSalesInvoice,
  // getAllPaymentSearch,
  markOR,
  // printBase64,
} from "../../Helpers/apiCalls/paymentAPI";
import { ToastContainer } from "react-toastify";
// import imageCompression from "compressorjs";
import passwordIcon from "../../Assets/Images/password.png";
import usernameIcon from "../../Assets/Images/username.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loginAuthorize } from "../../Helpers/apiCalls/authApi";
import html2canvas from "html2canvas";
import { SyncLoader } from "react-spinners";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import { printAsTextFile } from "../../Helpers/apiCalls/paymentAPI";
import MytFooter from "../../Components/MytFooter";

const { Option } = Select;

function ClosedInvoices() {
  const state = useLocation();
  const role = getRole();
  const [inactive, setInactive] = useState(true);
  const [orderID, setOrderID] = useState();
  const [pagesArray, setPagesArray] = useState([]);
  // const [text, setText] = useState(["", "", "", ""]);
  const [closeTable, setCloseTables] = useState([]);
  const [auhtenticateBy, setAuhtenticateBy] = useState('');
  const [printingInProgress, setPrintingInProgress] = useState(false);

  const [selectedOR, setSelectedOR] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const [openAuthorizeModal, setOpenAuthorizeModal] = useState(false);
  const [openModalOrderSummary, setOpenModalOrderSummary] = useState(false);
  const [discountDetails, setDiscountDetails] = useState([]);
  const [percentage, setPercentage] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [orders, setOrders] = useState({});
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
    page: 1,
  });

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [disableClick, setDisableClick] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [doneModal, setDoneModal] = useState(false);
  const [paymentBreakdown, setPaymentBreakdown] = useState([]);
  const [foodServer, setFoodServer] = useState("");

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  // const [orNo, setOrNo] = useState("");
  // const componentRefSummaryInvoice = useRef();
  // const [forNonVat, setForNonVat] = useState([]);

  const generatePages = (total, parts) => {
    const partSize = Math.ceil(parseInt(total) / parseInt(parts));
    return Array.from({ length: partSize }, (_, i) => ({
      id: i + 1,
      label: `Page ${i + 1}`,
    }));
  };

  const handleFilterPage = (e) => {
    setFilter((prev) => (
      {
        ...prev,
        page: e || 1,
      }
    ));
  };

  const handleSearchChange = (e) => {
    setFilter((prev) => (
      {
        ...prev,
        term: e || '',
        page: 1,
      }
    ));
  };
  
  const handleLeftClick = () => {
    setFilter((prev) => (
      {
        ...prev,
        page: parseInt(prev.page) - 1,
      }
    ));
  };

  const handleRightClick = () => {
    setFilter((prev) => (
      {
        ...prev,
        page: parseInt(prev.page) + 1,
      }
    ));
  };
  
  async function fetchPayments() {
    setShowLoader(true);
    // const response = await getAllPaymentSearch(
    //   filter.date_from,
    //   filter.date_to,
    //   orNo
    // );
    const payload = {
      date_from: filter.date_from,
      date_to: filter.date_to,
      or_no: filter.term,
      page: filter.page,
    };
    const response = await UseGetRequest(
      "payments/getAll",
      payload,
      // getRestoLogin()
    );
    if (response.data) {
      setPagesArray(generatePages(response.data.data.data.total_records, 10))
      setCloseTables(response.data.data.data.payments);
    } else {
      setCloseTables([]);
      setTimeout(() => setShowLoader(false), 2000);
    }
    setTimeout(() => setShowLoader(false), 2000);
  }

  React.useEffect(() => {
    fetchPayments();
  }, [filter]);

  async function fetchOrderInfo(id) {
    setOpenModalOrderSummary(true);
    // const response = await getGroupOrderID(id);
    const response = await UseGetRequest(
      "orders/show/" + id,
      {for_printing: "1"},
      // getRestoLogin()
    );
    if (response.data) {
      setOrderDetails(response.data.message.order_details);
      // setForNonVat(response.data.message.discounts_details);
      setPaymentInfo(response.data.message.payment);
      setPaymentBreakdown(response.data.message.payment_details);
      setOrders(response.data.message.order);
      setFoodServer(response.data.message.order.food_server);
      var arr = response.data.message.discounts_details.map((data) => {
        return data.percentage;
      });
      setPercentage(arr);
    }
  }

  async function fetchOrderDiscounts(orderID) {
    const response = await UseGetRequest(
      "order_discounts/show/" + orderID,
      {},
      // getRestoLogin()
    );
    if (response.data) {
      const res = response.data.order_discount_detail?.map((row) => {
        return {...row,
          discount_id: row.discount_id,
          name: row.customer_name,
          id: row.customer_id,
          discount_name: row.discount_type,
        };
      });
      setDiscountDetails(res);
    }
  }

  async function printOR(data) {
    fetchOrderInfo(data.order_id);
    fetchOrderDiscounts(data.order_id);
    setSelectedOR(data);
  }

  async function printNewOR() {
    setAllowPrint(true);
    const response = await markOR(
      selectedOR.order_id,
      "reprint",
      // getRestoLogin()
    );
    handlePrint();
    if (response.data) {
      toast.success("Marked OR reprint", {
        style: toastStyle(),
      });
    } else {
      setOpenModalOrderSummary(false);
      setAllowPrint(false);
    }
  }

  async function submit() {
    setDisableClick(true);
    const response = await loginAuthorize(
      username,
      password,
      "",
      // getRestoLogin()
    );
    if (response.data) {
      setAuhtenticateBy(response.data.id);
      setDoneModal(true);
      setOpenAuthorizeModal(false);
      toast.success("Successful Login!", { style: toastStyle() });
    } else {
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
    }
  }
  async function cancelSI() {
    const responses = await cancelSalesInvoice(
      auhtenticateBy,
      orderID,
      // getRestoLogin()
    );
    if (responses.data) {
      toast.success("SI Cancelled Successfully!");
      refreshPage();
    }
  }

  const handleCancel = (data) => {
    setOrderID(data.id);
    if (getRole() === "1" || getRole() === "7") {
      setDoneModal(true);
    } else {
      setOpenAuthorizeModal(true);
    }
  };

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  const divId = useRef(null); // Initialize useRef with null
  const [allowPrint, setAllowPrint] = useState(false);

  const handlePrint = () => {
    // setIsClicked(true)
    if (divId.current) {
      const element = divId.current;

      html2canvas(element, { scale: 1 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        // const newWindow = window.open();
        // if (newWindow) {
        //   // Write the image to the new window
        //   newWindow.document.write(`<img src="${imgData}" alt="Captured Image"/>`);
        //   newWindow.document.close();
        // }
        // printBase64Data(imgData);
        const blob = new Blob([imgData], { type: "text/plain" });
        const txtFile = new File([blob], "data.txt", { type: "text/plain" });
        handlePrintTextFile(txtFile)
      });
    }
  };

  // async function printBase64Data(image) {
  //   const response = await printBase64(
  //     window.printer_name,
  //     image,
  //     "0",
  //     getRestoLogin()
  //   );
  //   if (response.data) {
  //     setAllowPrint(false);
  //     setAllowPrint(false);
  //     if (getRole() === "1" || getRole() === "7") {
  //       refreshPage();
  //     } else {
  //       navigate("/orderingpage/");
  //     }
  //     refreshPage();
  //   } else {
  //     // setIsClicked(false)
  //   }
  // }

  async function handlePrintTextFile(txtFile) {
    setPrintingInProgress(true)
    const response = await printAsTextFile(
      window.printer_name,
      txtFile,
      "0",
      // getRestoLogin()
    );
    if (response.data) {
      setAllowPrint(false);
      setAllowPrint(false);
      if (getRole() === "1" || getRole() === "7") {
        refreshPage();
      } else {
        navigate("/orderingpage/");
      }
      refreshPage();
    } else {
      setPrintingInProgress(false)
      // setIsClicked(false)
    }
  }

  return (
    <div>
      <ToastContainer />
      {state.state === null && (
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Closed Invoices"} //Dashboard navbar index
          page={"Closed Invoices"}
        />
      )}
      <div
        className={`container ps-5 pt-4 full-height ${
          role === "2" ? "cashier" : inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col xl={6} lg={6} md={6} sm={6} xs={6}>
            <h1 className="page-title-menu">CLOSED INVOICES </h1>
          </Col>
          {state.state === null ? (
            <Col
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={6}
              className="d-flex justify-content-end"
            >
              <Input
                style={{ width: 250 }}
                suffix={<SearchOutlined />}
                placeholder="Search invoice no."
                className="h-60"
                onKeyDown={(e) =>
                  e.key === ("Enter" || "NumpadEnter") &&
                  handleSearchChange(e.target.value)
                }
                onChange={(e) => handleSearchChange(e.target.value)}
              />
            </Col>
          ) : (
            <>
              <Col
                xl={5}
                lg={5}
                md={5}
                sm={5}
                xs={5}
                className="d-flex justify-content-end"
              >
                <Input
                  style={{ width: 250 }}
                  suffix={<SearchOutlined />}
                  placeholder="Search invoice no."
                  className="h-60"
                  onKeyDown={(e) =>
                    e.key === ("Enter" || "NumpadEnter") &&
                    handleSearchChange(e.target.value)
                  }
                  onChange={(e) => handleSearchChange(e.target.value)}
                />
              </Col>
              <Col
                xl={1}
                lg={1}
                md={1}
                sm={1}
                xs={1}
                className="d-flex justify-content-end"
              >
                <Row>
                  <Col>
                    <button
                      size="sm"
                      className="invoice-back-btn"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>
                  </Col>
                </Row>
              </Col>
            </>
          )}
          <hr />
        </Row>
        <Row className="mb-3">
          <Col className="d-flex justify-content-left">
            <Row>
              {/* <Col className=" d-flex align-items-center">
                <span>FILTER BY DATE:</span>
              </Col> */}
              <Col>
                <div className="PO-filters d-flex align-items-center">
                  <span className="me-4">FROM:</span>
                  <Form.Control
                    size="md"
                    type="date"
                    name="date_from"
                    className="date-filter me-3"
                    onChange={handleFilter}
                    value={filter.date_from}
                  />
                  <span className="me-4">TO:</span>
                  <Form.Control
                    size="sm"
                    type="date"
                    name="date_to"
                    className="date-filter me-3"
                    onChange={handleFilter}
                    value={filter.date_to}
                  />
                  <span className="me-4">PAGES:</span>
                    <Select 
                        placeholder="All Pages"
                        showSearch
                        style={{ width: 500 }}
                        value={filter.page}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(e) => handleFilterPage(e)}
                    >
                      {pagesArray.map((option) => (
                          <Option key={option.id} value={option.id}>{option.label}</Option>
                      ))}
                    </Select>
                    <AntBtn
                      type="primary"
                      className='arrow-btn'
                      disabled={filter.page <= 1}
                      icon={<LeftOutlined />}
                      onClick={handleLeftClick}
                    />
                    <AntBtn
                      type="primary"
                      className='arrow-btn'
                      disabled={pagesArray.length === 0 ? true : filter.page >= pagesArray.length }
                      icon={<RightOutlined />}
                      onClick={handleRightClick}
                    />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {closeTable.length > 0 ? (
            <Row className="all-table-container">
              {closeTable.map((data) => {
                return (
                  <Col
                    xs={6}
                    md={4}
                    lg={3}
                    className="close-invoice-cards mt-1"
                  >
                    <Card title={`SI # ${data.id}`}>
                      <Row className="d-flex justify-content-between">
                        {data.is_deleted !== "1" ? (
                          <Col xs={6} className="">
                            <AntBtn
                              className="redo-cancel-button w-100"
                              onClick={() => handleCancel(data)}
                            >
                              Cancel
                            </AntBtn>
                          </Col>
                        ) : (
                          <Col>
                            <AntBtn
                              className="redo-cancel-button w-100"
                              disabled
                            >
                              Cancelled
                            </AntBtn>
                          </Col>
                        )}
                        {(data.is_deleted === "1" && data.is_printed === "1") ||
                        (data.is_deleted === "0" && data.is_printed === "0") ? (
                          <Col xs={6} className="d-flex justify-content-end">
                            <AntBtn
                              type="primary"
                              className="redo-print-button w-100"
                              onClick={() => printOR(data)}
                            >
                              Reprint
                            </AntBtn>
                          </Col>
                        ) : (
                          <Col>
                            <AntBtn
                              type="primary"
                              className="redo-print-button"
                              onClick={() => printOR(data)}
                            >
                              Print
                            </AntBtn>
                          </Col>
                        )}
                      </Row>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <Row className=" all-table-container">
              {showLoader ? (
                <Col className="p-5 d-flex justify-content-center center">
                  <SyncLoader color="var(--tertiary-color)" size={20} />
                </Col>
              ) : (
                <Col className="p-5 d-flex justify-content-center center">
                  <div className="redo-no-data-conts">
                    <span className="text-center"> No data found.</span>
                  </div>
                </Col>
              )}
            </Row>
          )}
        </Row>
        <MytFooter/>
      </div>

      <div ref={divId} className="hide-from-screen">
          <div className="d-flex justify-content-center">
            <CommonPrint
              isReprint
              type="officialReceipt"
              discounts={discountDetails}
              orderItems={orderDetails}
              orderInfo={orders}
              paymentDetails={paymentInfo}
              paymentBreakdown={paymentBreakdown}
              computedDiscount={{total_discount: selectedOR.discount, total_vat_exempt: selectedOR.vat_exemption}}
              serviceCharge={selectedOR.service_charge}
              superGrandTotal={selectedOR.total_amount}
              foodServer={foodServer}
            />
          </div>
        </div>

      {/* Authenticate login to discount */}
      <Modal
        size="md"
        show={openAuthorizeModal}
        onHide={() => setOpenAuthorizeModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="bold-font p-3">
          <h6>AUTHENTICATE LOGIN</h6>
          <Container>
            <Row className="mt-4 pt-4">
              <Col xl={3} lg={3} md={3} sm={3} xs={3}></Col>
              <Col xl={6} className="d-flex justify-content-center">
                <div className="input-group mb-3">
                  <div className="input-group-prepend icon-cont">
                    <span
                      className="input-group-text icon-text custom-border-radius"
                      id="basic-addon1"
                    >
                      <img
                        src={usernameIcon}
                        alt="username"
                        className="username-icon"
                      />
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control username-input"
                    placeholder="Username"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
              </Col>
              <Col xl={3} lg={3} md={3} sm={3} xs={3}></Col>
            </Row>
            <Row>
              <Col xl={3} lg={3} md={3} sm={3} xs={3}></Col>
              <Col xl={6} className="d-flex justify-content-center">
                <div className="input-group mb-3">
                  <div className="input-group-prepend icon-cont">
                    <span
                      className="input-group-text icon-text custom-border-radius"
                      id="basic-addon1"
                    >
                      <img
                        src={passwordIcon}
                        alt="password"
                        className="password-icon"
                      />
                    </span>
                  </div>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control username-input"
                    placeholder="Password"
                    aria-label="Password"
                    aria-describedby="basic-addon1"
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) =>
                      e.key === ("Enter" || "NumpadEnter") && submit()
                    }
                  />
                  <div className="eye-icon-login">
                    <FontAwesomeIcon
                      icon={showPassword ? "eye" : "eye-slash"}
                      alt={"eye"}
                      className={
                        showPassword
                          ? "eye-login eye-icon"
                          : "eye-slash-login eye-icon"
                      }
                      aria-hidden="true"
                      onClick={togglePassword}
                    />
                  </div>
                </div>
              </Col>
              <Col xl={3} lg={3} md={3} sm={3} xs={3}></Col>
            </Row>
            <Row className=" pt-4">
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col>
                <Button
                  className="cancel-btn"
                  onClick={() => setOpenAuthorizeModal(false)}
                >
                  CANCEL
                </Button>
              </Col>
              <Col className="d-flex justify-content-end">
                <Button className="save-btn" onClick={submit}>
                  SUBMIT
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={doneModal}
        onHide={() => setDoneModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          className="bold-font"
          title="Cancel Invoice"
        ></Modal.Header>
        <Modal.Body className="bold-font">
          <text className="custom-modal-body-title"> Cancel SI </text>
          <Row>
            <Col xs={12} className="p-3 d-flex justify-content-center">
              <h6 style={{ color: "var(--title-color)" }}>
                <strong>
                  Are you sure you want to cancel "Invoice # {orderID} " ?
                </strong>
              </h6>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col></Col>
            <Col className="d-flex justify-content-end">
              <Button
                size={"xs"}
                className="cancel-btn"
                onClick={() => setDoneModal(false)}
              >
                Back
              </Button>
            </Col>
            <Col className="d-flex justify-content-end">
              <Button
                size={"xs"}
                className="save-btn"
                onClick={() => cancelSI()}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      
      <Modal
        size="md"
        show={openModalOrderSummary}
        onHide={() => setOpenModalOrderSummary(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="bold-font">
          <h4>ORDER SUMMARY</h4>
          <hr />
          <Container>
            <Row>
              <Col>
                <h5>ITEM/S</h5>
              </Col>
              <Col className="d-flex justify-content-end">
                <h5>QTY</h5>
              </Col>
            </Row>
            <Row>
              <Col>
                {orderDetails?.map((data) => {
                  return (
                    <Row>
                      <Col>
                        <label>{data.menu_name}</label>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <label>{data.qty}</label>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
            <Row className="pt-5">
              <Col xl={4}></Col>
              <Col className="d-flex justify-content-end">
                <Button
                  className="cancel-btn"
                  onClick={() => setOpenModalOrderSummary(false)}
                >
                  CANCEL
                </Button>
              </Col>
              <Col className="">
                <Button className="save-btn w-100" onClick={printNewOR}>
                  REPRINT
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

{/* LOADER MODAL */}
      <AntModal
        maskClosable={false}
        open={printingInProgress}
        footer={null}
        closeIcon={false}
      >
        <AntRow className="d-flex justify-content-center">
          <Title level={5}>PRINTING IN PROGRESS</Title>
        </AntRow>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large"/>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </AntModal>
    </div>
  );
}

export default ClosedInvoices;
